
export const AllOperators = {
  date: [
    { text: "Equals", operator: "eq" },
    { text: "Less Than Equal To", operator: "lte" },
    { text: "Greater Than Equal To", operator: "gte" },
    { text: "Greater Than", operator: "gt" },
    { text: "Less Than", operator: "lt" },
    { text: "Year To Date", operator: "ytd" },
    { text: "Month To Date", operator: "mtd" },
    { text: "Between", operator: "between" },
    { text: "Is Null", operator: "isnull" },
  ],
  number: [
    { text: "Equals", operator: "eq" },
    { text: "Not Equals", operator: "neq" },
    { text: "Greater Than Equal To", operator: "gte" },
    { text: "Greater Than", operator: "gt" },
    { text: "Less Than Equal To", operator: "lte" },
    { text: "Less Than", operator: "lt" },
    { text: "Is Null", operator: "isnull" },
  ],
  numeric: [
    { text: "Equals", operator: "eq" },
    { text: "Not Equals", operator: "neq" },
    { text: "Greater Than Equal To", operator: "gte" },
    { text: "Greater Than", operator: "gt" },
    { text: "Less Than Equal To", operator: "lte" },
    { text: "Less Than", operator: "lt" },
    { text: "Is Null", operator: "isnull" },
  ],
  text: [
    { text: "Contains", operator: "contains" },
    { text: "Does Not Contain", operator: "doesnotcontain" },
    { text: "Equals", operator: "eq" },
    { text: "Not Equals", operator: "neq" },
    { text: "Starts With", operator: "startswith" },
    { text: "Ends With", operator: "endswith" },
    { text: "Is Null", operator: "isnull" },
  ],
  select: [
    { text: "Equals", operator: "eq" },
    { text: "Not Equals", operator: "neq" },
  ],
  boolean: [
    { text: "Equals", operator: "eq" },
    { text: "Not Equals", operator: "neq" },
    { text: "Is Null", operator: "isnull" },
  ],
};
